import React from 'react';
import Content from '../content/content.component';
import {
    pageSectionClassName,
    pageSectionHeadAsideClassName,
    pageSectionHeadClassName,
    pageSectionHeadTitleClassName,
    pageSectionInnerClassName,
    pageSectionThemeBlueClassName,
    pageSectionThemeGreenClassName
} from './page-section.style';
import { ThemeName } from '../../../types';
import Theme from '../theme/theme.component';

interface PageSectionProps {
    title?: React.ReactNode,
    aside?: React.ReactNode,
    theme?: ThemeName,
    children?: React.ReactNode
}

const PageSection: React.FC<PageSectionProps> = ({
    title,
    aside,
    theme = 'blue',
    children,
}) => (
    <Theme
        className={ pageSectionClassName }
        name={ theme }
        blueClassName={ pageSectionThemeBlueClassName }
        greenClassName={ pageSectionThemeGreenClassName }>
        { (title || aside) && (
            <Content>
                <div className={ pageSectionHeadClassName }>
                    { title && (
                        <div className={ pageSectionHeadTitleClassName }>
                            { title }
                        </div>
                    ) }

                    { aside && (
                        <div className={ pageSectionHeadAsideClassName }>
                            { aside }
                        </div>
                    ) }
                </div>
            </Content>
        ) }
        <Content>
            <div className={ pageSectionInnerClassName }>
                { children }
            </div>
        </Content>
    </Theme>
);

export default PageSection;
